import React, { Component } from 'react';
import { GenericSimpleButton, GenericSimpleIconButton } from 'com-gyf-webcore-userinterfacecomponents';

let addProduct, errorSave;
class Footer extends Component {
    constructor(props) {
        super(props);
        errorSave = props.errorSave;
        this.validateAddProduct = this.validateAddProduct.bind(this);
    }

    validateAddProduct() {
        this.props.validateAddProduct(this.props.data, this.props.form);
    }

    componentDidUpdate() {
       
    }

    render() {
        let saveButton = null;
        let cancelButton = null;
        if (this.props.data.readyRequest) {
            saveButton = <GenericSimpleIconButton text="Guardado en proceso... " buttonClass="btn btn-cta disabled" iconClass="fa fa-circle-o-notch fa-spin" />
        }
        else {
            saveButton = <GenericSimpleButton buttonType="button" text="Aceptar" buttonClass="btn btn-cta" onClick={this.validateAddProduct} buttonType="button" />
            cancelButton = <GenericSimpleButton buttonType="button" text="Cancelar" buttonClass="btn btn-secondary" onClick={this.props.cancelProduct} />
        }
        return (
            <div>
                <div className="row">
                    <div className="col-xs-2">
                        {saveButton}
                    </div>
                    <div className="col-xs-2">
                        {cancelButton}
                    </div>
                    <div className="col-xs-9"></div>
                </div>
            </div>
        );
    }
};

export default Footer;